import { ErrorMessage, Field, Form, Formik } from 'formik'
import { useState } from 'react'
import { TextEditor } from '../../forms/fields/TextEditor'
import FieldWrapper from '../../forms/FieldWrapper'
import Button from '../../general/Button'
import Translation from '../../Translation/cont/Translation'

const FlyerSettingsSection = ({flyerSettings, updateFlyerSettings, printType}) => {
    const {titleBottomText, titleTopText} = flyerSettings
    const [activeTitleBottomText, activateTitleBottomText] = useState(titleBottomText || titleBottomText === '' ? true : false)
    const [activeTitleTopText, activateTitleTopText] = useState(titleTopText || titleTopText === '' ? true : false)

    return (
        <Formik
            initialValues={flyerSettings}
            onSubmit={(values, actions) => {
                updateFlyerSettings(values)
            }}
            activeTitleBottomText={activeTitleBottomText}
            activeTitleTopText={activeTitleTopText}
        >
        {({ values, errors, status, touched, isSubmitting, handleReset, setFieldValue }) => (
            <Form>
                <fieldset>
                    <div className="form-content gap-20">
                        <div className='setting-wrapper gap-35'>
                            <label>
                                {printType === 'flyer' ? (<p className='gap-10'><Translation id="print_flyer_top_text">Individualisierung des oberen Textelements auf dem Titel</Translation></p>
                                ) : (
                                    <p className='gap-10'><Translation id="print_top_text">Individualisierung des oberen Textelements</Translation></p>
                                )}
                                <Field type="checkbox" checked={activeTitleTopText} id="active-title-top-text" className="checkbox tgl tgl-flat" onChange={() => {
                                    if(!activeTitleTopText) {
                                        if(!titleTopText) {
                                            setFieldValue('titleTopText', '')
                                        }
                                        activateTitleTopText(!activeTitleTopText)
                                    }
                                    
                                    if(activeTitleTopText) {
                                        if(titleTopText || titleTopText === '') {
                                            setFieldValue('titleTopText', null)
                                        }
                                        activateTitleTopText(!activeTitleTopText)
                                    }
                                }}/>
                                <span className="tgl-btn text-regular"><Translation id="print_flyer_activate_customization">Aktiv</Translation></span>
                            </label>

                            {activeTitleTopText && <FieldWrapper label="" id="content-title" classes="field-textarea field-textarea-text">
                                <TextEditor
                                    setFieldValue={(val) => setFieldValue("titleTopText", val)}
                                    value={values.titleTopText}
                                />
                                <ErrorMessage className="text-regular-color" name="titleTopText" component="div" /> 
                            </FieldWrapper>}
                        </div>
                        <div className='setting-wrapper gap-35'>
                            <label>
                                {printType === 'flyer' ? (<p className='gap-10'><Translation id="print_flyer_bottom_text">Individualisierung des unteren Textelements auf dem Titel</Translation></p>
                                ) : (
                                    <p className='gap-10'><Translation id="print_bottom_text">Individualisierung des unteren Textelements</Translation></p>
                                )}
                                <Field type="checkbox" checked={activeTitleBottomText} id="active-title-top-text" className="checkbox tgl tgl-flat" onChange={() => {
                                      if(!activeTitleBottomText) {
                                        if(!titleBottomText) {
                                            setFieldValue('titleBottomText', '')
                                        }
                                        activateTitleBottomText (!activeTitleBottomText)
                                    }
                                    
                                    if(activeTitleBottomText) {
                                        if(titleBottomText ||titleBottomText === '') {
                                            setFieldValue('titleBottomText', null)
                                        }
                                        activateTitleBottomText (!activeTitleBottomText)
                                    }
                                }}/>
                                <span className="tgl-btn text-regular"><Translation id="print_flyer_activate_customization">Aktiv</Translation></span>
                            </label>
                            {activeTitleBottomText && <FieldWrapper label="" id="content-title" classes="field-textarea field-textarea-text">
                                <TextEditor
                                    setFieldValue={(val) => setFieldValue("titleBottomText", val)}
                                    value={values.titleBottomText}
                                />
                                <ErrorMessage className="text-regular-color" name="titleBottomText" component="div" /> 
                            </FieldWrapper>}
                        </div>
                    </div>
                    <Button
                        className="button-submit"
                        transId={"save_button"}
                        hideText={false}
                        type="submit"
                    />
                </fieldset>
            </Form>
        )}
    </Formik>
    )
}

export default FlyerSettingsSection